import React from 'react'

import { Container, ConnectContainer, Contact, EmailLinke, CopyrightCopy } from './styledComponents'

export const Footer = () => {
	return (
		<Container>
			<ConnectContainer>
				<Contact>
					Contact Us at{' '}
					<EmailLinke href='mailto:info@rcmssoftware.com'>
						info@rcmssoftware.com
					</EmailLinke>
				</Contact>
				{/*<p style={styles.policyLinks}>
						<Link to='/terms-of-service' style={styles.links}>Terms Of Service</Link> - <Link to='/privacy-policy' style={styles.links}>Privacy Policy</Link>
					</p>*/}
				<CopyrightCopy>
					© {new Date().getFullYear()} 38th Street Studios, Inc. All rights reserved.
				</CopyrightCopy>
			</ConnectContainer>
		</Container>
	)
}
